<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <ShieldIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('superadmin.toolsName') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link :to="{ name: 'choose-role' }" tag="a" class="btn shadow-md flex items-center">
          <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
        </router-link>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <div class="
          flex flex-col
          lg:flex-row
          border-b border-gray-200
          dark:border-dark-5
          pb-5
          -mx-5
        ">
        <div class="flex flex-1 px-5 items-center justify-center lg:justify-start">
          <div class="ml-5">
            <div class="
                w-24
                sm:w-40
                truncate
                sm:whitespace-normal
                font-medium
                text-lg
              ">
              {{ $t('superadmin.tools.deleteUser.title') }}
            </div>
            <div class="
                col-span-6
                sm:col-span-3
                xl:col-span-2
                flex flex-col
                justify-end
                items-center
              " v-if="this.isDeleteUserProcessing">
              <LoadingIcon icon="three-dots" class="w-8 h-8" />
            </div>
            <div class="text-gray-600" v-if="!this.isDeleteUserProcessing">
              <div class="mt-3">
                <label for="mail" class="form-label w-full flex flex-col sm:flex-row">
                  Email
                </label>
                <input id="mail" v-model.trim="validateDeleteUser.email.$model" type="text" name="mail" class="
                  intro-y
import apiHost from '@/services/api.settings'
                  form-control
                  py-3
                  px-4
                  box
                  pr-10
                  placeholder-theme-13
                " :class="{ 'border-theme-6': validateDeleteUser.email.$error }" placeholder="info@info.info" />
                <template v-if="validateDeleteUser.email.$error">
                  <div v-for="(error, index) in validateDeleteUser.email.$errors" :key="index" class="text-theme-6 mt-2">
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <button type="button" @click="deleteUser" v-show="!this.isDeleteUserConfirm" class="
                btn btn-warning-soft
                w-40
                dark:border-dark-5 dark:text-gray-300
                mr-1
              ">
                  {{ $t('superadmin.tools.deleteUser.delete') }}
                </button>
                <button type="button" @click="deleteUser" v-show="this.isDeleteUserConfirm" class="
                btn btn-warning
                w-40
                dark:border-dark-5 dark:text-gray-300
                mr-1
              ">
                  {{ $t('superadmin.tools.deleteUser.deleteConfirm') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content-delete-user" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('superadmin.tools.deleteUser.success') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content-delete-user" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('superadmin.tools.deleteUser.failed') }}!</div>
      <!-- <div class="text-gray-600 mt-1">{{ errorNote }}</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, reactive, toRefs } from 'vue'
import superadminApi from '../../services/superadmin/superadmin.api.js'
import Toastify from 'toastify-js'
import { helpers, email, required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default defineComponent({
  components: {},
  methods: {
    deleteUser() {
      this.validateDeleteUser.$touch()
      if (this.validateDeleteUser.email.$error) {
        return
      }
      if (this.isDeleteUserConfirm !== true) {
        this.isDeleteUserConfirm = true
        return
      }
      this.isDeleteUserProcessing = true

      const data = {
        email: this.formDataDeleteUser.email
      }

      superadminApi.deleteUser(data).then(
        response => {
          Toastify({
            node: cash('#success-notification-content-delete-user')
              .clone()
              .removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.isDeleteUserConfirm = false
          this.isDeleteUserProcessing = false
          this.formDataDeleteUser.email = ''
          this.validateDeleteUser.email.$reset()
        },
        error => {
          console.log(error)
          Toastify({
            node: cash('#failed-notification-content-delete-user')
              .clone()
              .removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.isDeleteUserConfirm = false
          this.isDeleteUserProcessing = false
          this.validateDeleteUser.email.$reset()
        }
      )
    }
  },
  computed: {
    console: () => console
  },
  data() {
    return {
      isDeleteUserConfirm: false,
      isDeleteUserProcessing: false
    }
  },
  mounted() { },
  setup() {
    const formDataDeleteUser = reactive({
      email: ''
    })
    const rulesDeleteUser = {
      email: {
        required: helpers.withMessage('form.validation.email', required),
        email: helpers.withMessage('form.validation.email', email)
      }
    }
    const validateDeleteUser = useVuelidate(rulesDeleteUser, toRefs(formDataDeleteUser))

    return {
      validateDeleteUser,
      formDataDeleteUser
    }
  }
})
</script>
